module.exports = window["core-js/modules/es.promise.js"];